// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '/app';
const ROOTS_ERP = '/app/erp';

// ----------------------------------------------------------------------

export const PATH_HOME = {
  components: '/components',
  cloud: 'https://www.sketch.com/s/0fa4699d-a3ff-4cd5-a3a7-d851eb7e17f0',
  purchase: 'https://material-ui.com/store/items/minimal-dashboard/',
  dashboard: ROOTS_DASHBOARD
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    dashboard: path(ROOTS_DASHBOARD, '/dashboard'),
    sitemap: path(ROOTS_DASHBOARD, '/sitemap'),
    account: path(ROOTS_DASHBOARD, '/account'),
    energy: path(ROOTS_DASHBOARD, '/energy'),
    plantInsights: path(ROOTS_DASHBOARD, '/plant-insights'),
    logs: path(ROOTS_DASHBOARD, '/logs'),
    templates: path(ROOTS_DASHBOARD, '/templates'),
    batches: path(ROOTS_DASHBOARD, '/batches'),
    wastewater: path(ROOTS_DASHBOARD, '/wastewater'),
    status: path(ROOTS_DASHBOARD, '/status'),
    paymentsuccess: path(ROOTS_DASHBOARD, '/subscription-success'),
    developer: path(ROOTS_DASHBOARD, '/developer'),
    configuration: path(ROOTS_DASHBOARD, '/configuration'),
    admin: path(ROOTS_DASHBOARD, '/admin'),
    contract: path(ROOTS_DASHBOARD, '/contract'),
    integrations: path(ROOTS_DASHBOARD, '/integrations'),
    network: path(ROOTS_DASHBOARD, '/network'),
    changelog: path(ROOTS_DASHBOARD, '/changelog'),
    assistant: path(ROOTS_DASHBOARD, '/assistant'),
    export: path(ROOTS_DASHBOARD, '/export'),
    docs: path(ROOTS_DASHBOARD, '/docs')
  },
  erp: {
    root: ROOTS_ERP,
    dashboard: path(ROOTS_ERP, '/dashboard'),
    productTypes: path(ROOTS_ERP, '/product-types'),
    processFlows: path(ROOTS_ERP, '/process-flows'),
    processFlowDetail: (id) => path(ROOTS_ERP, `/process-flows/${id}`),
    recipeDetail: (id) => path(ROOTS_ERP, `/recipes/${id}`),
    // Phase 1+ (routes exist, pages come later)
    ingredients: path(ROOTS_ERP, '/ingredients'),
    recipes: path(ROOTS_ERP, '/recipes'),
    production: path(ROOTS_ERP, '/production'),
    packaging: path(ROOTS_ERP, '/packaging'),
    inventory: path(ROOTS_ERP, '/inventory'),
    barrels: path(ROOTS_ERP, '/barrels'),
    barrelDetail: (id) => path(ROOTS_ERP, `/barrels/${id}`),
    orders: path(ROOTS_ERP, '/orders'),
    orderDetail: (id) => path(ROOTS_ERP, `/orders/${id}`),
    customers: path(ROOTS_ERP, '/customers'),
    customerDetail: (id) => path(ROOTS_ERP, `/customers/${id}`),
    picking: path(ROOTS_ERP, '/picking'),
    pickingDetail: (id) => path(ROOTS_ERP, `/picking/${id}`),
    shipping: path(ROOTS_ERP, '/shipping'),
    shippingDetail: (id) => path(ROOTS_ERP, `/shipping/${id}`),
    integrations: path(ROOTS_ERP, '/integrations'),
    skus: path(ROOTS_ERP, '/skus'),
    skuDetail: (id) => path(ROOTS_ERP, `/skus/${id}`),
    excise: path(ROOTS_ERP, '/excise'),
    suppliers: path(ROOTS_ERP, '/suppliers'),
    purchases: path(ROOTS_ERP, '/purchases'),
    scheduling: path(ROOTS_ERP, '/scheduling'),
    settings: path(ROOTS_ERP, '/settings'),
    userGuide: path(ROOTS_ERP, '/user-guide')
  }
};
